var map = {
	"./BUCT_logo.png": 6278,
	"./CET.png": 4005,
	"./HZ4Z_logo.png": 2842,
	"./Ovler.png": 7172,
	"./Poclass.png": 3330,
	"./SNC_logo.png": 3572,
	"./ZAC_logo.jpg": 5399,
	"./ace.png": 1459,
	"./address_image.svg": 599,
	"./animated_logo.svg": 7733,
	"./blogs_image.svg": 3890,
	"./buctbase.png": 8158,
	"./cloud_infrastructure.svg": 7957,
	"./codeInLogo.png": 7935,
	"./contactMail.png": 9581,
	"./coursera_logo.png": 1877,
	"./data_science.svg": 8938,
	"./deeplearning_ai_logo.png": 2862,
	"./delhivery_logo.png": 4625,
	"./developerActivity.svg": 6715,
	"./drive.jpg": 2517,
	"./drive.png": 9150,
	"./dsc_logo.png": 6390,
	"./education.svg": 855,
	"./experience.svg": 9917,
	"./feelingProud.svg": 658,
	"./freecopy_logo.png": 9273,
	"./fullstack.svg": 2043,
	"./gcp_logo.png": 1513,
	"./github_logo.png": 9551,
	"./googleAssistant.jpg": 700,
	"./googleAssistant.svg": 3564,
	"./google_logo.png": 5927,
	"./ibm_logo.png": 9561,
	"./intel_logo.jpg": 3026,
	"./iotlab.jpg": 8779,
	"./jsFramework.svg": 8446,
	"./legato_logo.png": 5112,
	"./manOnTable.svg": 3034,
	"./micro.jpg": 4750,
	"./microsoft_logo.png": 7231,
	"./mozilla_logo.png": 9592,
	"./muffito_logo.png": 2295,
	"./nextuLogo.jpg": 1631,
	"./nptel_logo.png": 8936,
	"./organic.jpg": 1475,
	"./portfolio.gif": 3549,
	"./programmer.svg": 9220,
	"./projects_image.svg": 4716,
	"./pwa.png": 7758,
	"./qq.jpg": 6426,
	"./record.m4a": 5922,
	"./saayaHealthLogo.png": 6006,
	"./stanford_logo.png": 7137,
	"./talksCardBack.svg": 5331,
	"./talksCardBackAlt.svg": 7945,
	"./telegram.jpg": 8219,
	"./ui_ux_design.svg": 2337,
	"./undraw_ideas_flow_re_bmea.svg": 8621,
	"./undraw_ideas_re_7twj.svg": 9909,
	"./undraw_scientist_re_fs04.svg": 1644,
	"./undraw_speech_to_text_re_8mtf.svg": 1064,
	"./wechat.png": 4506,
	"./zac2.png": 5184
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;